import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const FakulteSekreteri = () => {
  const { t } = useTranslation();

  const secretary = t('faculty_secretary', { returnObjects: true });

  return (
    <PageTemplate title={secretary.page_title}>
      <div className="flex flex-col items-center text-center">
        <img
          src={secretary.photo}
          alt={secretary.name}
          className="rounded-full h-48 w-48 object-cover shadow-lg mb-4"
        />
        <h2 className="text-2xl font-bold text-hacettepe-blue">{secretary.name}</h2>
        <p className="text-lg text-gray-600">{secretary.title}</p>
        <div className="mt-4 text-left">
          <p className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-hacettepe-blue" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            <strong>{t('email')}:</strong> <a href={`mailto:${secretary.email}`} className="ml-1 text-blue-500 hover:underline">{secretary.email}</a>
          </p>
          <p className="flex items-center mt-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-hacettepe-blue" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.518.76a11.034 11.034 0 006.364 6.364l.76-1.518a1 1 0 011.06-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            <strong>{t('phone')}:</strong> <span className="ml-1">{secretary.phone}</span>
          </p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default FakulteSekreteri;
